<template>
<div class="chapter">
<div class="inner_page">
<div class="otherbooks" id="adc">
<p class="center">Also by Eric Frattini</p>
<p class="center"><span class="small">SELECTED NONFICTION</span></p>
<p class="center"><em>Los Espías del Papa</em></p>
<p class="center"><em>CIA. Joyas de Familia</em></p>
<p class="center"><em>La Conjura, Matar a Lorenzo de Medici</em></p>
<p class="center"><em>ONU, historia de la corrupción</em></p>
<p class="center"><em>Secretos Vaticanos</em></p>
<p class="center"><em>Mafia S.A. 100 Años de Cosa Nostra</em></p>
<p class="center"><em>Osama bin Laden, la espada de Alá</em></p>
<p class="center"><span class="small">FICTION</span></p>
<p class="center"><em>El Quinto Mandamiento</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312375942_epub_adc_r1.vue?74cfd0d2